import { UIView } from "@uirouter/react";

export const SalesIntelligenceContainer = () => {
    return (
        <div className="sw-layout-scrollable-element use-sticky-css-rendering">
            <UIView className="fadeIn" />
        </div>
    );
};
